
var valid = false;
if (jQuery) {  
	var version = jQuery().jquery;
	var groups = /(\d+)\.(\d+)/.exec(version);
	if (groups[1] > 1 || groups[2] >= 5)
		valid = true;
}

if (valid) {
	var remoteHostline = '//gift-reggie.eshopadmin.com';
	var serverHostline = '/apps/giftregistry';
	var cartJS = "/cart.js";
	var accountLine = "/account";

	if (/^\/mock/.test(window.location.pathname)) {
		// For the test server. People in production, you can ignore this.
		serverHostline = '/mock/proxy';
		remoteHostline = 'http://localhost:3001';
		cartJS = "/mock/cart.js";
		accountLine = "/mock/account";
	}

	var giftReggieCookieName = "giftreggie_session_cookie";

	function setCookie(c_name,value,exdays)
	{
		var exdate=new Date();
		exdate.setDate(exdate.getDate() + exdays);
		var c_value=escape(value) + ((exdays==null) ? "" : "; expires="+exdate.toUTCString());
		c_value += "; path=/";
		document.cookie=c_name + "=" + c_value;
	}

	function getCookie(c_name) {
		var c_value = document.cookie;
		var c_start = c_value.indexOf(" " + c_name + "=");
		if (c_start == -1)
			c_start = c_value.indexOf(c_name + "=");
		if (c_start == -1)
			c_value = null;
		else {
			c_start = c_value.indexOf("=", c_start) + 1;
			var c_end = c_value.indexOf(";", c_start);
			if (c_end == -1)
				c_end = c_value.length;
			c_value = unescape(c_value.substring(c_start,c_end));
		}
		return c_value;
	}

	function getSessionId() {
		var value = getCookie(giftReggieCookieName);
		if (!value || value == "undefined" || value == "null")
			return null;
		return value;
	}
	
	function getServerTime() {
		return Math.floor(new Date().getTime() / 1000);
	}

	function signOAuth(ajaxOptions, shopifyId, sharedSecret) {
		var method = "GET";
		if (ajaxOptions['type'])
			method = ajaxOptions['type'];
		if (!ajaxOptions['headers'])
			ajaxOptions['headers'] = {};
		var urlBase = ajaxOptions['url'];
		var userKey = "oauth_consumer_key=" + shopifyId;
		// This is fine, because even though the nonce is not actually a unique number; it only works for the duration of the server's uptime.
		// If the server restarts, it clears the nonces.
		var nonce = "oauth_nonce=" + Math.floor(Math.random()*1000000000);
		var signatureMethod = "oauth_signature_method=HMAC-SHA256";
		var timestamp = "oauth_timestamp=" + getServerTime();
		var version = "oauth_version=1.0";

		var signature = method.toUpperCase() + "&" + encodeURIComponent(urlBase) + "&" + encodeURIComponent(userKey + nonce + signatureMethod + timestamp + version);
		var calculatedSignature = CryptoJS.HmacSHA256(signature, sharedSecret);

		ajaxOptions.headers['Authorization'] = userKey;
		ajaxOptions.headers['Authorization'] += ", " + nonce;
		ajaxOptions.headers['Authorization'] += ", " + timestamp;
		ajaxOptions.headers['Authorization'] += ", " + signatureMethod;
		ajaxOptions.headers['Authorization'] += ", " + version;
		ajaxOptions.headers['Authorization'] += ", oauth_signature=" + calculatedSignature;
		return ajaxOptions;
	}


	function deleteCookie(c_name) {
		document.cookie = c_name + '=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	}

	
	(function($) {
		// This is bad, but actually works without badgering our servers.
		// If shopify stays relatively consistent, we'll keep this, otherwise we should move this to our servers.
		loggedInCheckHack = function () {
			// Here's how we do. We ajax to /account.js. If we're logged in, we'll get a content-type that's application/json.
			// If we're not, we'll get a redirect to /account/login, which'll be served up as text/html. We can check these via getResponseHeader.
			var deferred = $.Deferred();
			$.ajax({url: accountLine + ".js", dataType: 'html'}).done(function(data, status, xhr) {
				if (/html/.test(xhr.getResponseHeader("Content-Type")))
					deferred.reject();
				else
					deferred.resolve();
			});
			return deferred;
		}

		showDialog = function(type, cookie) {
			if (cookie && cookie.registry_id)
				$('#giftreggie-' + type + (cookie.admin ? '-admin' : '')).slideDown();
			else if (cookie && cookie.wishlist_id)
				$('#giftreggie-' + type + '-wishlist').slideDown();
		}

		registryError = function(message) {
			$('.giftreggie-product-status').html("<div class='error'>" + message + "</div>");
		}

		registrySuccess = function(message) {
			$('.giftreggie-product-status').html("<div class='success'>" + message + "</div>");
		}
		wishlistSuccess = function(message) { return registrySuccess(message); }
		wishlistError = function(message) { return registryError(message); }

		var savedReggieQuantities = {};
		updateProductTable = function (cookie, product, registry) {
			var admin = cookie.admin;
			var isWishlist = cookie['wishlist_id'] ? 1 : 0;
			var variant_index = {};
			if (!isWishlist) {
				if (registry && registry.products.length > 0) {
					for (var i = 0; i < registry.products[0].variants.length; ++i) {
						variant_index[registry.products[0].variants[i].id] = registry.products[0].variants[i];
						savedReggieQuantities[registry.products[0].variants[i].id] = registry.products[0].variants[i].quantity;
					}
				}
				if (admin) {
					for (var i = 0; i < product.variants.length; ++i) {
						var variant = product.variants[i];
						var variant_title = variant.title;
						if (variant_title == "Default Title" || variant_title == "Default")
							variant_title = product.title;
						$('#giftreggie-product-table').append("<input type='hidden' id='giftreggie-product-id' value='" + product.id + "'/>");
						$('#giftreggie-product-table').append("<div class='giftreggie-product-row'>\
						<div class='giftreggie-title'>" + variant_title + "</div><div class='giftreggie-purchased'>" + (variant_index[variant.id] ? variant_index[variant.id].purchased : 0) + 
						"</div> / <div class='giftreggie-quantity'><input type='text'class='giftreggie-variant-quantity' maxlength=3 value='" + (variant_index[variant.id] ? variant_index[variant.id].quantity : 0) + "'/></div>\
						<input type='hidden' class='giftreggie-variant-id' value='" + variant.id + "'/></div>");
					}
					if (registry) {
						$('#giftreggie-product-admin-change').show();
						$('#giftreggie-product-admin-add').hide();
					}
					else {
						$('#giftreggie-product-admin-change').hide();
						$('#giftreggie-product-admin-add').show();
					}
				}
				else {
					for (var i = 0; i < product.variants.length; ++i) {
						var variant = product.variants[i];
						if (!variant_index[variant.id])
							continue;
						var registry_variant = variant_index[variant.id];
						$('#giftreggie-variants, #giftreggie-variants-wishlist').append('<li><span>' + (variant.title == "Default Title" ? product.title : variant.title) + '</span> <span>' + (registry_variant.quantity - registry_variant.purchased) + '</span></li>');
					}
				}
			}
			else {
				var titles = {};
				for (var i = 0; i < product.variants.length; ++i) {
					var variant = product.variants[i];
					var variant_title = variant.title;
					if (variant_title == "Default Title")
						variant_title = product.title;
					titles[variant.id] = variant_title;
					$('#giftreggie-product-table').append("<input type='hidden' id='giftreggie-product-id' value='" + product.id + "'/>");
					$('#giftreggie-variants-wishlist').append("<div class='giftreggie-product-row'>\
					<div class='giftreggie-title'>" + variant_title + "</div><div class='giftreggie-wishlist'><input data-id='" + variant.id + "' type='button' class='wishlisttoggle addbutton' value='✔'/></div>");
				}
				var variant_hash = {};
				for (var i = 0; i < cookie.variant_ids.length; ++i)
					variant_hash[cookie.variant_ids[i]] = 1;
				$('#giftreggie-variants-wishlist .addbutton').each(function() {
					if (variant_hash[$(this).attr('data-id')]) {
						$(this).removeClass("addbutton");
						$(this).addClass("rmbutton");
						$(this).val('×');
					}
				});
				$('.wishlisttoggle').click(function() {
					var button = $(this);
					var sessionId = getSessionId();
					$('.wishlisttoggle').attr('disabled', 'disabled');
					if ($(this).hasClass('addbutton')) {
						// Add to wishlist.
						$.ajax({ url: serverHostline + "/api/wishlist/add?sid=" + encodeURIComponent(sessionId), type: 'POST', dataType: 'json', contentType: 'json', data: JSON.stringify({ id: button.attr('data-id') }) }).done(function() {
							wishlistSuccess("Added " + titles[button.attr('data-id')] + " to your wishlist.");
							button.removeClass('addbutton');
							button.addClass('rmbutton');
							button.val('×');
							cookie.variant_ids.push(button.attr('data-id'));
							setCookie("giftreggie-logged", JSON.stringify(cookie));
							$('.wishlisttoggle').removeAttr('disabled');
						}).fail(function(jqXHR) {
							wishlistError("Unable to modify wishlist: " + JSON.parse(jqXHR.responseText).error);
							$('.wishlisttoggle').removeAttr('disabled');
						});
					}
					else {
						// Remove from wishlist.
						$.ajax({ url: serverHostline + "/api/wishlist/remove?sid=" + encodeURIComponent(sessionId), type: 'POST', dataType: 'json', contentType: 'json', data: JSON.stringify({ id: button.attr('data-id') }) }).done(function() {
							wishlistSuccess("Removed " + titles[button.attr('data-id')] + " from your wishlist.");
							button.removeClass('rmbutton');
							button.addClass('addbutton');
							button.val('✔');
							for(var i = cookie.variant_ids.length-1; i >= 0; i--) {
								if(cookie.variant_ids[i] === button.attr('data-id')) {
									cookie.variant_ids.splice(i, 1);
									break;
								}
							}
							setCookie("giftreggie-logged", JSON.stringify(cookie));
							$('.wishlisttoggle').removeAttr('disabled');
						}).fail(function(jqXHR) {
							wishlistError("Unable to modify wishlist: " + JSON.parse(jqXHR.responseText).error);
							$('.wishlisttoggle').removeAttr('disabled');
						});
					}
					return false;
				});
			}
		}



		modifyProductRegistry = function (registryId) {			
			var variantList = $.map($.grep($('.giftreggie-product-row'), function(e, i) {
				var id = $(e).children(".giftreggie-variant-id").val();
				var savedQuantity = savedReggieQuantities[id] ? savedReggieQuantities[id] : 0;
				var newQuantity = $(e).find(".giftreggie-variant-quantity").val();
				return savedQuantity != newQuantity;
			}), function(value) {
				return { id: $(value).children(".giftreggie-variant-id").val(), quantity: $(value).find(".giftreggie-variant-quantity").val() };
			});
			if (variantList.length > 0) {				
				$('.giftreggie-popup input').attr('disabled', 'disabled');
				$('.giftreggie-popup .spinner').show();
				$.ajax({ url: serverHostline + '/api/registry/' + registryId + '/product?sid=' + encodeURIComponent(getSessionId()), type: 'PUT', dataType: 'json', contentType: 'json', data: JSON.stringify({
					products: [{ 
						id: $('#giftreggie-product-id').val(), 
						variants: variantList
					}]
				})}).done(function() {
					registrySuccess("Tu lista se ha modificado con éxito!");
					for (var i = 0; i < variantList; ++i)
						savedReggieQuantities[variantList[i].id] = variantList[i].quantity;
					$('#giftreggie-product-admin-add').hide();
					$('#giftreggie-product-admin-change').show();
					$('.giftreggie-popup input').removeAttr('disabled');
					$('.giftreggie-popup .spinner').hide();
				}).fail(function() {
					registryError("Unable to modify registry. Please try going to <a href='" + serverHostline + "'>this page</a>, and then returning. Apologies for the bug. If the issue still persists, please contact the store owner.");
					$('.giftreggie-popup input').removeAttr('disabled');
					$('.giftreggie-popup .spinner').hide();
				});
			} else {
				registryError("No changes made to regsistry.");
			}
			
		}

		removeProductRegistry = function(registryId) {
			var variantList = $.map($.grep($('.giftreggie-product-row'), function(e, i) {
				var id = $(e).children(".giftreggie-variant-id").val();
				var savedQuantity = savedReggieQuantities[id] ? savedReggieQuantities[id] : 0;
				return savedQuantity > 0;
			}), function(value) {
				return { id: $(value).children(".giftreggie-variant-id").val(), quantity: $(value).find(".giftreggie-variant-quantity").val() };
			});
			
			$('.giftreggie-popup input').attr('disabled', 'disabled');
			$('.giftreggie-popup .spinner').show();
			$.ajax({ url: serverHostline + '/api/registry/' + registryId + '/product/' + $('#giftreggie-product-id').val() + '?sid=' + encodeURIComponent(getSessionId()), type: 'DELETE', dataType: 'json', contentType: 'json', data: JSON.stringify({
				products: [{ 
					id: $('#giftreggie-product-id').val(), 
					variants: $.map($('.giftreggie-product-row'), function(value) {
						return { id: $(value).children(".giftreggie-variant-id").val(), quantity: $(value).find(".giftreggie-variant-quantity").val() };
					})
				}]
			})}).done(function() {
				registrySuccess("Has eliminado este producto de tu lista de regalos!");
				for (var i = 0; i < variantList.length; ++i)
					savedReggieQuantities[variantList[i].id] = 0;
				$('#giftreggie-product-admin-add').show();
				$('#giftreggie-product-admin-change').hide();
				$("#giftreggie-product-table input[type='text']").val('0');
				$('.giftreggie-popup input').removeAttr('disabled');
				$('.giftreggie-popup .spinner').hide();
			}).fail(function() {
				registryError("Unable to remove product from registry. Please try going to <a href='" + serverHostline + "'>this page</a>, and then returning. Apologies for the bug. If the issue still persists, please contact the store owner.");
				$('.giftreggie-popup input').removeAttr('disabled');
				$('.giftreggie-popup .spinner').hide();
			});
		}

		// This should be cleared upon checkout. If you checkout in a non-standard way, then 
		clearGiftreggieSession = function() {
			deleteCookie("giftreggie-logged");
		}

		$(document).ready(function() {
			var url = window.location.pathname;
			var loggedRegistry = getCookie("giftreggie-logged");
			var sessionId = getSessionId();
			
			
			if (loggedRegistry != null) {
				var loggedJSON = JSON.parse(loggedRegistry);
				var registryId = loggedJSON.registry_id;
				registryId = registryId ? registryId : '';
				var registryName = loggedJSON.registry_title;
				var admin = loggedJSON.admin;
				var hasCollections = /collections/.test(url);
				var hasProducts = /products/.test(url);
				var isWishlist = loggedJSON['wishlist_id'] ? 1 : 0;
				
				// Don't throw up the pop up if they have the button on the page.
				if ($('.gift-reggie-wishlist-button').length > 0 && isWishlist) {
					return;
				}
				
				
				$.ajax({url: cartJS, dataType: 'json', contentType: 'json'}).done(function(data) {
					var token = data.token;
					if (token != null && loggedJSON.token == null) {
						loggedJSON.token = token;
						setCookie("giftreggie-logged", JSON.stringify(loggedJSON));
					}
					else if (token != loggedJSON.token) {
						clearGiftreggieSession();
					}
				});
				if (loggedJSON.admin) {
					loggedInCheckHack().fail(function() {
						clearGiftreggieSession();
						if (hasCollections || hasProducts)
							window.location.reload();
					});
				}
				$('body').append("<style>\
					.giftreggie-popup { background-color: white; padding: 10px; border-right: 1px solid black; border-bottom: 1px solid black; position: fixed; display: none; left: 0; top: 0; width: 350px; z-index:10000; font-family: 'Trade'; font-size: 13px; font-weight: 300; }\
					.giftreggie-popup-close { cursor: pointer; top: 0px; right: 10px; position: absolute; }\
					.giftreggie-popup-minimize { cursor: pointer; top: 0px; right: 24px; position: absolute; }\
					#giftreggie-variants li span:first-child:after { content:' x '; }\
					#giftreggie-product-table > div { display: block; border-bottom: 1px solid #AAA; }\
					#giftreggie-product-table > div > div { display: inline-block; } \
					#giftreggie-product-table > div > div:first-child { width: 70%; } \
					.giftreggie-product-row div { display: inline-block;  }\
					.giftreggie-product-row div:first-child { width: 70%; }\
					.giftreggie-product-row input { width: 30px; }\
					.giftreggie-popup h2 { margin-top: 0; font-family: 'Quicksand'; color: #eb1d7e; }\
					.giftreggie-product-status { margin-top: 10px; } \
					.giftreggie-product-status .error { color: red; }\
					.giftreggie-product-status .success { color: green; }\
					.giftreggie-popup .spinner { display: none; }\
					#giftreggie-product-admin { overflow-y: scroll; max-height: 80%; }\
					.giftreggie-popup input[type='button'].addbutton { background:none; background-color: #FFF; border: #777 1px solid; }\
					.giftreggie-popup input[type='button'].rmbutton { background:none; background-color: #AAA; border: #333 1px solid; }\
					.giftreggie-popup-stop { margin: 0 auto; display: block; margin-bottom: 12px; }\
					.giftreggie-popup button, .giftreggie-popup input[type='button'], .giftreggie-popup input[type='submit'] {\
						border-radius: 0px;\
						padding: 2px 4px;\
						line-height: 18px;\
						font-weight: 700;\
						font-size: 12px;\
						letter-spacing: 1px;\
						background-color: #ee0a7b;\
						color: #FFF;\
						font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\
						border: 0;\
						margin-bottom: 8px;\
					}\
				</style>\
				<div class='giftreggie-popup' id='giftreggie-product'>\
					<a class='giftreggie-popup-minimize'>&ndash;</a>\
					<a class='giftreggie-popup-close'>&times;</a>\
					<div class='giftreggie-popup-body' id='giftreggie-product-info'>\
						<h2 class='giftreggie-registry-notification'></h2>\
						<input type='button' class='giftreggie-popup-stop' value='Salir de esta lista de regalos'/>\
						<p>Este product está en la lista de regalos! Para comprarlo, agrégalo a tu carrito a la derecha y realiza el checkout. Automáticamente se marcará como comprado en la lista de regalos, para que nadie lo repita. Nosotros nos ocuparemos de envolverlo y llevarlo al lugar del evento!</p>\
						<ul id='giftreggie-variants'>\
						</ul>\
					</div>\
				</div>\
				\
				<div class='giftreggie-popup' id='giftreggie-collection'>\
					<a class='giftreggie-popup-minimize'>&ndash;</a>\
					<a class='giftreggie-popup-close'>&times;</a>\
					<div class='giftreggie-popup-body' id='giftreggie-collection-info'>\
						<h2 class='giftreggie-registry-notification'></h2>\
						<input type='button' class='giftreggie-popup-stop' value='Stop Shopping for this Registry'/>\
						<p>Para comprarlo, agrégalo a tu carrito a la derecha y realiza el checkout. Automáticamente se marcará como comprando en la lista de regalos, para que nadie lo repita. Nosotros nos ocuparemos de envolverlo y llevarlo al lugar del event!</p>\
					</div>\
				</div>\
				\
				<div class='giftreggie-popup' id='giftreggie-product-admin'>\
					<a class='giftreggie-popup-minimize'>&ndash;</a>\
					<a class='giftreggie-popup-close'>&times;</a>\
					<div class='giftreggie-popup-body'>\
						<h2 class='giftreggie-registry-notification'></h2>\
						<input type='button' class='giftreggie-popup-stop' value='Salir de esta lista de regalos'/>\
						<!-- If we're not on the registry. -->\
						<div style='display:none' id='giftreggie-product-admin-add'>\
							<p>Este producto no está en tu lista de regalos! Completa con la cantidad y haz click en el botón debajo, para agregarlo.</p>\
							<div class='giftreggie-product-status'></div>\
							<p>\
								<input type='button' style='margin:0' onclick='modifyProductRegistry(" + registryId + ");' value='Agregar a la lista de regalos' /></input>\
								<span class='spinner'><img src='" + remoteHostline + "/static/img/catalyst/ajax-loader-f5f5f5.gif'/ ></span>\
							</p>\
						</div>\
						<!-- If we are on the registry. -->\
						<div style='display:none' id='giftreggie-product-admin-change'>\
							<p>Este producto está en la lista de regalos! Este producto ya se encuentra en tu lista de regalos! Puedes modificarlo debajo.</p>\
							<div class='giftreggie-product-status'></div>\
							<p>\
								<input type='button' onclick='modifyProductRegistry(" + registryId + ");' value='Cambiar las cantidades'></input>\
								<input type='button' onclick='removeProductRegistry(" + registryId + ");' value='Eliminar de mi lista de regalos'></input>\
								<span class='spinner'><img src='" + remoteHostline + "/static/img/catalyst/ajax-loader-f5f5f5.gif'/ ></span>\
							</p>\
						</div>\
						<div id='giftreggie-product-table'>\
							<div>\
								<div>Nombre del producto</div><div>Tengo/Quiero</div>\
							</div>\
						</div>\
					</div>\
				</div>\
				\
				<div class='giftreggie-popup' id='giftreggie-collection-admin'>\
					<a class='giftreggie-popup-minimize'>&ndash;</a>\
					<a class='giftreggie-popup-close'>&times;</a>\
					<div class='giftreggie-popup-body'>\
						<h2 class='giftreggie-registry-notification'></h2>\
						<input type='button' class='giftreggie-popup-stop' value='Salir de esta lista de regalos'/>\
						<p>Bienvenida al navegador para tu lista de regalos. Cada vez que entres a la página de un producto, aparecerá un cartel que te dará la opción de agregar ese producto a tu lista de regalos. Este cartel aparecerá en la esquina superior izquierda de tu pantalla. ¡Ya puedes comenzar a buscar los productos que te gusten y agregarlos a tu lista!</p>\
					</div>\
				</div>\
				<div class='giftreggie-popup' id='giftreggie-collection-wishlist'>\
					<a class='giftreggie-popup-minimize'>&ndash;</a>\
					<a class='giftreggie-popup-close'>&times;</a>\
					<div class='giftreggie-popup-body'>\
						<h2>You are currently administering your <a href='" + serverHostline + "/wishlist'>wishlist</a>.</h2>\
						<input type='button' class='giftreggie-popup-stop' value='Stop managing your wishlist.'/>\
						<p>Welcome to the admin browsing mode of your wishlist. As you navigate through the site, when you come to a product page, you'll be prompted to add the product to the wishlist (or not). This dialog will appear in the top right corner of every valid product page. To get started, simply click on any of the products below.</p>\
					</div>\
				</div>\
				<div class='giftreggie-popup' id='giftreggie-product-wishlist'>\
					<a class='giftreggie-popup-minimize'>&ndash;</a>\
					<a class='giftreggie-popup-close'>&times;</a>\
					<div class='giftreggie-popup-body' id='giftreggie-product-info'>\
						<h2>You are currently administering your <a href='" + serverHostline + "/wishlist?sid=" + encodeURIComponent(sessionId) + "'>wishlist</a>.</h2>\
						<input type='button' class='giftreggie-popup-stop' value='Stop managing your wishlist.'/>\
						<p>You can use the following controls below to modify whether or not this product is your wishlist.</p>\
						<p>A <input class='addbutton' type='button' value='✔'/> next to an item indicates it is not on your wishlist. Click it to add it to your list.<br/>\
						A <input class='rmbutton' type='button' value='×'/> next to an item indicates it is on your wishlist. Click it to remove the item from your list.</p>\
						<div class='giftreggie-product-status'></div>\
						<ul id='giftreggie-variants-wishlist'>\
						</ul>\
					</div>\
				</div>");
				$('.giftreggie-registry-notification').html("Ahora estás " + (admin ? "manejando" : "comprando para") + " <a href='"+ serverHostline + "/registry/" + registryId + "?sid=" + getSessionId() + "'>" + registryName + "</a>.");
				if (hasCollections || hasProducts) {
					if (!hasProducts) {
						// Display first dialog if we don't have a cookie already doing it.
						//if (getCookie("gift-reggie-initial") == null) {
							showDialog("collection", loggedJSON);
						//	setCookie("gift-reggie-initial", 0);
						//}
					}
					else {
						var groups = /(.*)\/products\/([\w-]+)/.exec(url);
						if (groups && groups.length > 2) {
							var prior = groups[1]
							var handle = groups[2];
							var cart = {};
							$.ajax({url: prior + '/products/' + handle + '.js', dataType: 'json'}).done(function(product) {
								if (!isWishlist) {
									$.ajax({ url: serverHostline + '/api/registry/' + registryId + '/product/' + product.id, dataType: 'json'}).done(function(registry) {
										var shouldShow = false;
										for (var i = 0; i < registry.products.length; ++i) {
											for (var j = 0; j < registry.products[i].variants.length; ++j) {
												if (registry.products[i].variants[j].purchased < registry.products[i].variants[j].quantity)
													shouldShow = true;
											}
										}
										if (shouldShow) {
											showDialog("product", loggedJSON);
											updateProductTable(loggedJSON, product, registry);
										}
									}).fail(function () {
										if (admin) {
											showDialog("product", loggedJSON);
											updateProductTable(loggedJSON, product);
										}
									});
								}
								else {
									updateProductTable(loggedJSON, product);
									showDialog("product", loggedJSON);
								}
							});
						}
					}
				}
				$('.giftreggie-popup-close').click(function() { $(this).parents(".giftreggie-popup").slideUp(); });
				var initial_width = $('.giftreggie-popup').width();
				var initial_height;
				$('.giftreggie-popup-minimize').click(function() {
					var selector = $(this).parent().children(".giftreggie-popup-body");
					if (selector.is(":visible")) {
						initial_height = selector.height();
						selector.animate({ height: 0 }, 400, 'swing', function() { $(this).hide(); });
						$('.giftreggie-popup').css('overflow-y', 'hidden');
						$('.giftreggie-popup').animate({ width: 30 });
					}
					else {
						selector.show();
						selector.animate({ height: initial_height });
						$('.giftreggie-popup').removeAttr('style');
						$('.giftreggie-popup').animate({ width: initial_width });
					}
				});
				if (window.giftreggiePopupDone)
					window.giftreggiePopupDone.resolve();
				$('.giftreggie-popup-stop').click(function() {
					var button = $(this);
					$(this).attr('disabled', 'disabled');
					$.ajax({ url: "/cart/update.js", type: "POST", dataType: 'json', data: { 'attributes[registry_id]': '', 'attributes[registry_admin]': '' } }).done(function() {
						button.parents(".giftreggie-popup").slideUp();
						deleteCookie("giftreggie-logged");
						deleteCookie("giftreggie-address");
					}).fail(function() {
						button.removeAttr('disabled');
					});
				});
			}
			if (sessionId) {
				$('a').each(function() {
					var href = $(this).attr('href');
					if (/\/apps\/gift-reggie/.test(href) && !/sid=/.test(href)) {
						if (href.indexOf("?") !== -1) {
							if (href == "?")
								href = href + "sid=" + encodeURIComponent(sessionId);
							else 
								href = href + "&sid=" + encodeURIComponent(sessionId);
						}
						else
							href = href + "?sid=" + encodeURIComponent(sessionId);
						$(this).attr('href', href);
					}
				})
			}
		});
	})(jQuery);
	
}